/**
 * Reusable empty state block.
 * Usage:
 *   <EmptyState
 *     illustration={<EmptyOffers />}
 *     title="Nessuna offerta"
 *     description="Crea la prima offerta con il bottone in alto."
 *     action={<button>Nuova offerta</button>}
 *   />
 */
import React from "react";

export function EmptyState({
  illustration,
  title,
  description,
  action,
  testid,
  compact = false,
}) {
  return (
    <div
      className={compact ? "py-8 px-4 text-center" : "py-14 px-6 text-center"}
      data-testid={testid || "empty-state"}
    >
      {illustration && (
        <div
          className="mx-auto flex items-center justify-center mb-3"
          style={{ color: "var(--text-muted)" }}
        >
          {illustration}
        </div>
      )}
      <div
        className="text-[14px] font-semibold"
        style={{ color: "var(--text-primary)" }}
      >
        {title}
      </div>
      {description && (
        <div
          className="text-[12px] mt-1 max-w-md mx-auto"
          style={{ color: "var(--text-muted)" }}
        >
          {description}
        </div>
      )}
      {action && <div className="mt-4 inline-flex">{action}</div>}
    </div>
  );
}
